// filepath: c:\Users\dtyzl\desti\src\api\bazi.js

export async function analyzeBazi(
  yearStem,
  yearBranch,
  monthStem,
  monthBranch,
  dayStem,
  dayBranch,
  hourStem,
  hourBranch,
  language = "en",
  mode = "hybrid"
) {
  const payload = {
    year_stem: yearStem,
    year_branch: yearBranch,
    month_stem: monthStem,
    month_branch: monthBranch,
    day_stem: dayStem,
    day_branch: dayBranch,
    hour_stem: hourStem,
    hour_branch: hourBranch,
    language,
    mode
  };

  const response = await fetch("http://localhost:8000/bazi/analyze", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });

  const data = await response.json();
  return data.result;
}